import React, { memo } from "react";
import { FormControl, FormControlLabel, RadioGroup, Radio } from "@mui/material";
import { connectionTypeCheckedIconMapper, connectionTypeIconMapper } from "../../constants/WebMap";

const ConnectionTypeGroup = ({ data = [], value, handleChange }) => {

  const controlProps = (item) => ({
    inputProps: { "aria-label": item },
  });

  return (
    <>
      <FormControl style={{ width: "100%" }}>
        <RadioGroup
          row
          aria-labelledby={"radio-group-horizontal"}
          name={"radio-group-horizontal"}
          value={value}
          onChange={(e) => {
            handleChange(e.target.value);
          }}
          style={{ width: "100%", display: "flex" }}
        >
          {data.map((item, idx) => (
            <FormControlLabel
              key={idx}
              value={item.value}
              sx={{
                m: 0,
                flex: 1,
                height: "20px",
                display: "flex",
                justifyContent: "center",
                ...(item.value === value && {
                  backgroundColor: "#007842",
                  color: "white"
                }),
                borderRadius: `${idx === 0 && idx === data.length - 1
                  ? "12px 12px 12px 12px"
                  : idx === 0
                    ? "12px 0px 0px 12px"
                    : idx === data.length - 1 && "0px 12px 12px 0px"
                  }`,
                border: '1px solid rgba(0, 120, 66, 0.5)',
                '.MuiFormControlLabel-label': {
                  fontSize: 13
                },
              }}
              control={
                <Radio
                  {...controlProps({ label: item.label })}
                  sx={{
                    display: "none"
                  }}
                />
              }
              label={
                <div style={{ height: "15px",textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center", margin: "2px 0px"}}>
                  {connectionTypeIconMapper[`${item.label}`] &&
                     <img
                     src={item.value === value
                       ? connectionTypeCheckedIconMapper[`${item.label}`]
                       : connectionTypeIconMapper[`${item.label}`]
                     }
                     alt={item.label}
                     style={{ maxWidth: "100%", maxHeight: "100%"}}
                     vertical-align="middle"
                   />
                  }
                  {!connectionTypeIconMapper[`${item.label}`] &&
                    <span style={{ wordBreak: "break-word"}}> {item.label} </span>
                  }
                 
                </div>
              }
            />
          ))}
        </RadioGroup>
      </FormControl>
    </>
  )
};

export default memo(ConnectionTypeGroup);